import React, { useEffect, useState } from 'react';
import "./style/style-pc.css"
import "./style/style-mob.css"
import { Prices } from './Prices';
import { Footer } from './Footer';
import { AboutUs } from './AboutUs';
import { Banner } from './Banner';
import img from "../../resources/logo.webp"
import img1 from "../../resources/img-1.jpeg"
import img2 from "../../resources/img-2.jpeg"
import img3 from "../../resources/img-3.jpeg"
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export const Home = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    const [age, setAge] = React.useState(() => {
        return localStorage.getItem("selectedLanguage") || "10";
    });

    const handleChange = (event) => {
        const newValue = event.target.value;
        setAge(newValue);
        localStorage.setItem("selectedLanguage", newValue);

        window.location.reload();
      };

    useEffect(() => {
        document.title = 'Barber Zajednica';
        setIsLoaded(true);

        const storedLanguage = localStorage.getItem("selectedLanguage");
        if (storedLanguage) {
            setAge(storedLanguage);
        }

        const handleStorageChange = () => {
            setAge(localStorage.getItem("selectedLanguage") || "10");
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
}, []);

    return (
        <div className='barbershop-zajednica-page'>
            <Box sx={{ minWidth: 30 }} className="jezik-fade-in ">
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" style={{color:"white"}}>
                        {age == 20 ? "Language" : "Jezik"}
                    </InputLabel>
                    <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={age}
                    label={age == 20 ? "Language" : "Jezik"}
                    onChange={handleChange}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                backgroundColor: "#282727",
                                color: "white",
                            }
                        }
                    }}
                    sx={{
                        color: "white",
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#fff !important",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#fff !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#fff !important",
                        },
                    }}
                    >
                    <MenuItem value={10}>Srpski</MenuItem>
                    <MenuItem value={20}>English</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <div className='barbershop-zajednica-banner'>
                <Banner />
            </div>
            <div className='barbershop-zajednica-about-us'>
                <AboutUs />
                <div className={`barbershop-zajednica-about-us-text ${isLoaded ? 'fade-in' : ''}`}>
                    {age == 20 
                        ? 
                        `Welcome to the Barber Community, a place where tradition and style go hand in hand.
                        With attention to every detail and the wishes of our clients, we strive to make every visit a special experience.
                        We believe that a good haircut is not just about appearance but also about the confidence you carry with you.
                        Join us and discover why we are the preferred choice of modern men.`

                        :
                        `Dobrodošli u Barber Zajednicu, mesto gde tradicija i stil idu ruku pod ruku.
                        Sa pažnjom prema svakom detalju i željama klijenata, trudimo se da svaka poseta bude 
                        posebno iskustvo. Verujemo da dobra frizura nije samo izgled, već i osećaj 
                        samopouzdanja koji nosite sa sobom. Pridružite nam se i otkrijte zašto smo omiljeni 
                        izbor modernih muškaraca.`
                    }          
                </div>
                <div className='barbershop-zajednica-about-us-logo'>
                    <img src={img} />
                </div>
            </div>
            <div className='barbershop-zajednica-prices'>
                <Prices />
            </div>
            <div className='barbershop-zajednica-images'>
                <div className='barbershop-zajednica-images-single-img'>
                    <img src={img1} />
                </div>
                <div className='barbershop-zajednica-images-single-img'>
                    <img src={img2} />
                </div>
                <div className='barbershop-zajednica-images-single-img'>
                    <img src={img3} />
                </div>
            </div>
            <div className='barbershop-zajednica-footer'>
                <Footer />
            </div>
        </div>
    );
};
